import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import { domOnlyProps } from 'utils/dom-only-props'

import styles from './text-area.css'

const TextArea = ({ data, placeholder }) => (
  <textarea
    placeholder={placeholder}
    rows={6}
    styleName="textarea"
    {...domOnlyProps(data)}
  >
  </textarea>
)

TextArea.propTypes = {
  data: PropTypes.object.isRequired,
  placeholder: PropTypes.string.isRequired,
}

export default CSSModules(TextArea, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/text-area/text-area.js
 **/